import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link
      to={`/categories/${item?.slug || item?.slugPath}`}
      className="category-card-wrapper"
    >
      <div className="category-card">
        {/* Image Container with Funky Border */}
        <div className="category-image-container">
          {item?.image ? (
            <img 
              src={item.image} 
              alt={item.name} 
              className="category-image" 
              loading="lazy"
            />
          ) : (
            <div className="category-image-placeholder">No Image</div>
          )}
          
          {/* Subtle gradient overlay that appears on hover */}
          <div className="category-overlay"></div>
        </div>
        
        {/* Card Content Area */}
        <div className="category-content">
          <h3 className="category-title">{item?.name || "Category"}</h3>
          
          <div className="category-action">
            <span className="shop-now-text">EXPLORE</span>
            <span className="arrow-icon">→</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Card;